import styled from 'styled-components'
import device from '../../utilities/device'
interface ActionButtonProps {
  white?: boolean
}
const ActionButton = styled.button<ActionButtonProps>`
  background-color: ${props =>
    props.white ? props.theme.colorWhite : props.theme.colorLime};
  color: ${({ theme }) => theme.colorVeryDarkBlue};
  padding: 10px 20px;
  border-radius: 5px;
  border: 0px solid white;
  cursor: pointer;
  &:hover {
    background-color: ${props =>
      props.white ? props.theme.colorLightGray : props.theme.colorBrightLime};
  }
  @media ${device.laptop} {
    font-size: 18px;
  }
`

export default ActionButton
